/**
 * Message Block Component
 */
import React, { useEffect, useRef } from "react";
import { Fab, Grid, Tooltip } from "@mui/material";
import { List } from "@mui/material";
import { ListItem } from "@mui/material";
import { ListItemText } from "@mui/material";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";

// const useStyles = makeStyles({
//   table: {
//     minWidth: 650,
//   },
//   chatSection: {
//     width: "100%",
//     height: "80vh",
//   },
//   headBG: {
//     backgroundColor: "#e0e0e0",
//   },
//   borderRight500: {
//     borderRight: "1px solid #e0e0e0",
//   },
//   messageArea: {
//     height: "70vh",
//     overflowY: "auto",
//   },
// });

const Message = ({
  even,
  adminPhotoUrl,
  data,
  selectedUserPhotoUrl,
  defaultAudioSpeed = 1,
  selecionarResponder,
}) => {
  useEffect(() => {
    if (data.audio) {
      const audioControl = document.getElementById(`audio${data.messageId}`);
      audioControl.playbackRate = defaultAudioSpeed;
    }
  }, [defaultAudioSpeed]);

  const altura = window.innerHeight - 300;
  // const classes = useStyles();

  // if (even) {
  //   return (
  //     <div className="d-flex flex-nowrap mb-3">
  //       <Avatar
  //         alt="user profile"
  //         src={selectedUserPhotoUrl}
  //         className="img-fluid rounded-circle mr-15 align-self-start"
  //       />
  //       <div className="chat-bubble-wrap">
  //         <div
  //           className="chat-bubble even bg-aqua"
  //           style={{ padding: 10, borderRadius: "25px" }}
  //         >
  //           <div
  //             style={{
  //               fontWeight: "bolder",
  //               paddingLeft: 10,
  //               paddingBottom: 10,
  //             }}
  //           >
  //             {data.author}
  //           </div>

  //           {data.message !== "" && <p className="mb-0">{data.message}</p>}

  //           {data.audio !== "" && (
  //             <div>
  //               <audio id={`audio${data.messageId}`} preload="none" controls>
  //                 <source src={data.audio} />
  //               </audio>
  //               {data.tempoAudio && (
  //                 <p
  //                   style={{ fontWeight: "bolder", marginLeft: "15px" }}
  //                   className="mb-0"
  //                 >
  //                   {data.tempoAudio}
  //                 </p>
  //               )}
  //             </div>
  //           )}
  //         </div>
  //         <span className="text-left d-block font-xs text-muted mt-1">
  //           {data.sent}
  //         </span>
  //       </div>
  //     </div>
  //   );
  // }
  return (
    <div className="d-flex flex-nowrap flex-row-reverse mb-3">
      {/* 
      <div className="chat-bubble-wrap">
        <div
          className="chat-bubble odd bg-primary text-white"
          style={{ padding: 10, borderRadius: "25px" }}
        >
          <div
            style={{ fontWeight: "bolder", paddingLeft: 10, paddingBottom: 10 }}
          >
            {data.author}
          </div>

          {data.message !== "" && <p className="mb-0">{data.message}</p>}

          {data.audio !== "" && (
            <div>
              <audio id={`audio${data.messageId}`} preload="none" controls>
                <source src={data.audio} />
              </audio>
              {data.tempoAudio && (
                <p
                  style={{ fontWeight: "bolder", marginLeft: "15px" }}
                  className="mb-0"
                >
                  {data.tempoAudio}
                </p>
              )}
            </div>
          )}
        </div>
        <span className="text-right d-block font-xs text-muted mt-1">
          {data.sent}
        </span>
      </div> */}
      <Grid style={{ overflow: "auto", background: "#ffffff" }}>
        <Grid item xs={9}>
          <List>
            <>
              {even && (
                <ListItem style={{ justifyContent: "start" }} key="1">
                  <Grid
                    container
                    style={{
                      width: "40%",
                      borderRadius: 5,
                      // color: "white",
                      textAlign: "center",
                    }}
                  >
                    <Grid
                      style={{
                        background: "#E1EBFF",
                        borderRadius: 5,
                        textAlign: "center",
                      }}
                      container
                    >
                      <Grid item xs={data.emRespostaAId ? 6 : 12}>
                        <ListItemText
                          style={{
                            marginLeft: 10,
                            fontWeight: "bolder",
                          }}
                          align="left"
                        >
                          <p style={{ fontWeight: "bolder" }}>{data.author}</p>
                        </ListItemText>
                      </Grid>

                      {data.emRespostaAId && (
                        <Grid item xs={6}>
                          <ListItemText
                            style={{
                              marginRight: 10,
                              fontWeight: "bolder",
                            }}
                            align="right"
                          >
                            <p style={{ fontSize: "0.800rem" }}>
                              Em resposta a
                            </p>
                          </ListItemText>
                        </Grid>
                      )}

                      {data.emRespostaAId && (
                        <ListItem
                          style={{
                            justifyContent: "start",
                            background: "white",
                            margin: 10,
                            borderRadius: 5,
                          }}
                          key="1"
                        >
                          <Grid container alignItems="center">
                            <Grid
                              style={{
                                background: "#E1EBFF",
                                // width: "30%",
                                borderRadius: 5,
                                textAlign: "center",
                                color: "black",
                              }}
                              container
                              alignItems="center"
                            >
                              <Grid container xs={8}>
                                <Grid item xs={12}>
                                  <ListItemText
                                    style={{ marginLeft: 10 }}
                                    align="left"
                                  >
                                    <p style={{ fontWeight: "bolder" }}>
                                      {data.profissionalNome}
                                    </p>
                                  </ListItemText>
                                </Grid>
                                <Grid item xs={12}>
                                  <>
                                    {data.message !== "" && (
                                      <ListItemText
                                        style={{ marginLeft: 10 }}
                                        align="left"
                                        primary={data.emRespostaATexto}
                                      ></ListItemText>
                                    )}
                                    {data.emRespostaAAudio !== "" && (
                                      <>
                                        <audio
                                          id={`audio${data.emRespostaAId}`}
                                          preload="none"
                                          controls
                                        >
                                          <source src={data.emRespostaAAudio} />
                                        </audio>
                                        {data.tempoAudio && (
                                          <p
                                            style={{
                                              fontWeight: "bolder",
                                              marginLeft: "15px",
                                            }}
                                            className="mb-0"
                                          >
                                            {data.tempoAudio}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                background: "white",
                              }}
                            >
                              <ListItemText
                                align="left"
                                secondary={data.sent}
                              ></ListItemText>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )}

                      <Grid container item xs={12} style={{ margin: 10 }}>
                        <Grid xs={10}>
                          {data.message !== "" && (
                            <ListItemText
                              style={{ marginLeft: 10 }}
                              align="left"
                              primary={data.message}
                            ></ListItemText>
                          )}
                          {data.audio !== "" && (
                            <Grid container>
                              <Grid xs={12}>
                                <audio
                                  id={`audio${data.messageId}`}
                                  preload="none"
                                  controls
                                >
                                  <source src={data.audio} />
                                </audio>
                              </Grid>

                              {/* {data.tempoAudio && (
                                <Grid xs={12}>
                                  <p
                                    style={{
                                      fontWeight: "bolder",
                                      marginLeft: "15px",
                                      // color: "white",
                                    }}
                                    className="mb-0"
                                  >
                                    {data.tempoAudio}
                                  </p>
                                </Grid>
                              )} */}
                            </Grid>
                          )}
                        </Grid>
                        <Grid
                          xs={2}
                          style={{
                            alignItems: "center",
                            display: "flex",
                            justifyContent: "end",
                          }}
                        >
                          <Tooltip title="Responder">
                            <Fab
                              color="info"
                              aria-label="add"
                              size="small"
                              onClick={() => selecionarResponder(data)}
                              style={{ marginRight: "10px" }}
                            >
                              <KeyboardReturnIcon />
                            </Fab>
                          </Tooltip>
                        </Grid>

                        {data.audio !== "" && data.tempoAudio && (
                          <Grid xs={12}>
                            <p
                              style={{
                                fontWeight: "bolder",
                                marginLeft: "15px",
                                // color: "white",
                              }}
                              className="mb-0"
                            >
                              {data.tempoAudio}
                            </p>
                          </Grid>
                        )}
                      </Grid>
                      {/* <Grid
                        xs={6}
                        style={{
                          alignItems: "center",
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        <Tooltip title="Responder">
                          <Fab
                            color="info"
                            aria-label="add"
                            size="small"
                            onClick={() => selecionarResponder(data)}
                          >
                            <KeyboardReturnIcon />
                          </Fab>
                        </Tooltip>
                      </Grid> */}
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      style={{
                        background: "white",
                      }}
                    >
                      <ListItemText
                        align="left"
                        secondary={data.sent}
                      ></ListItemText>
                    </Grid>
                  </Grid>
                  {/* <Grid container alignItems="center">
                    <Grid
                      style={{
                        background: "#E1EBFF",
                        width: "30%",
                        borderRadius: 5,
                        textAlign: "center",
                      }}
                      container
                      alignItems="center"
                    >
                      <Grid container xs={8}>
                        {data.emRespostaAId && (
                          <Grid item xs={6}>
                            <ListItemText
                              style={{
                                marginRight: 10,
                                // color: "white",
                                fontWeight: "bolder",
                              }}
                              align="right"
                            >
                              <p style={{ fontSize: "0.800rem" }}>
                                Em resposta a
                              </p>
                            </ListItemText>
                          </Grid>
                        )}

                        {data.emRespostaAId && (
                          <ListItem
                            style={{
                              justifyContent: "start",
                              background: "white",
                              margin: 10,
                              borderRadius: 5,
                            }}
                            key="1"
                          >
                            <Grid container alignItems="center">
                              <Grid
                                style={{
                                  background: "#E1EBFF",
                                  // width: "30%",
                                  borderRadius: 5,
                                  textAlign: "center",
                                  color: "black",
                                }}
                                container
                                alignItems="center"
                              >
                                <Grid container xs={8}>
                                  <Grid item xs={12}>
                                    <ListItemText
                                      style={{ marginLeft: 10 }}
                                      align="left"
                                    >
                                      <p style={{ fontWeight: "bolder" }}>
                                        {data.profissionalNome}
                                      </p>
                                    </ListItemText>
                                  </Grid>
                                  <Grid item xs={12}>
                                    <>
                                      {data.message !== "" && (
                                        <ListItemText
                                          style={{ marginLeft: 10 }}
                                          align="left"
                                          primary={data.emRespostaATexto}
                                        ></ListItemText>
                                      )}
                                      {data.emRespostaAAudio !== "" && (
                                        <>
                                          <audio
                                            id={`audio${data.emRespostaAId}`}
                                            preload="none"
                                            controls
                                          >
                                            <source
                                              src={data.emRespostaAAudio}
                                            />
                                          </audio>
                                          {data.tempoAudio && (
                                            <p
                                              style={{
                                                fontWeight: "bolder",
                                                marginLeft: "15px",
                                              }}
                                              className="mb-0"
                                            >
                                              {data.tempoAudio}
                                            </p>
                                          )}
                                        </>
                                      )}
                                    </>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                style={{
                                  background: "white",
                                }}
                              >
                                <ListItemText
                                  align="left"
                                  secondary={data.sent}
                                ></ListItemText>
                              </Grid>
                            </Grid>
                          </ListItem>
                        )}

                        <Grid item xs={12}>
                          <ListItemText style={{ marginLeft: 10 }} align="left">
                            <p style={{ fontWeight: "bolder" }}>
                              {data.author}
                            </p>
                          </ListItemText>
                        </Grid>
                        <Grid item xs={12}>
                          <>
                            {data.message !== "" && (
                              <ListItemText
                                style={{ marginLeft: 10 }}
                                align="left"
                                primary={data.message}
                              ></ListItemText>
                            )}
                            {data.audio !== "" && (
                              <>
                                <audio
                                  id={`audio${data.messageId}`}
                                  preload="none"
                                  controls
                                >
                                  <source src={data.audio} />
                                </audio>
                                {data.tempoAudio && (
                                  <p
                                    style={{
                                      fontWeight: "bolder",
                                      marginLeft: "15px",
                                    }}
                                    className="mb-0"
                                  >
                                    {data.tempoAudio}
                                  </p>
                                )}
                              </>
                            )}
                          </>
                        </Grid>
                      </Grid>
                      <Grid xs={4}>
                        <Tooltip title="Responder">
                          <Fab
                            color="info"
                            aria-label="add"
                            size="small"
                            onClick={() => selecionarResponder(data)}
                          >
                            <KeyboardReturnIcon />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        background: "white",
                      }}
                    >
                      <ListItemText
                        align="left"
                        secondary={data.sent}
                      ></ListItemText>
                    </Grid>
                  </Grid> */}
                </ListItem>
              )}
              {!even && (
                <ListItem style={{ justifyContent: "end" }} key="1">
                  <Grid
                    container
                    style={{
                      width: "40%",
                      borderRadius: 5,
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    <Grid
                      style={{
                        background: "#F7B014",
                        borderRadius: 5,
                        color: "white",
                        textAlign: "center",
                      }}
                      container
                    >
                      <Grid item xs={6}>
                        <ListItemText
                          style={{
                            marginLeft: 10,
                            color: "white",
                            fontWeight: "bolder",
                          }}
                          align="left"
                        >
                          <p style={{ fontWeight: "bolder" }}>{data.author}</p>
                        </ListItemText>
                      </Grid>

                      {data.emRespostaAId && (
                        <Grid item xs={6}>
                          <ListItemText
                            style={{
                              marginRight: 10,
                              color: "white",
                              fontWeight: "bolder",
                            }}
                            align="right"
                          >
                            <p style={{ fontSize: "0.800rem" }}>
                              Em resposta a
                            </p>
                          </ListItemText>
                        </Grid>
                      )}

                      {data.emRespostaAId && (
                        <ListItem
                          style={{
                            justifyContent: "start",
                            background: "white",
                            margin: 10,
                            borderRadius: 5,
                          }}
                          key="1"
                        >
                          <Grid container alignItems="center">
                            <Grid
                              style={{
                                background: "#E1EBFF",
                                // width: "30%",
                                borderRadius: 5,
                                textAlign: "center",
                                color: "black",
                              }}
                              container
                              alignItems="center"
                            >
                              <Grid container xs={8}>
                                <Grid item xs={12}>
                                  <ListItemText
                                    style={{ marginLeft: 10 }}
                                    align="left"
                                  >
                                    <p style={{ fontWeight: "bolder" }}>
                                      {data.profissionalNome}
                                    </p>
                                  </ListItemText>
                                </Grid>
                                <Grid item xs={12}>
                                  <>
                                    {data.message !== "" && (
                                      <ListItemText
                                        style={{ marginLeft: 10 }}
                                        align="left"
                                        primary={data.emRespostaATexto}
                                      ></ListItemText>
                                    )}
                                    {data.emRespostaAAudio !== "" && (
                                      <>
                                        <audio
                                          id={`audio${data.emRespostaAId}`}
                                          preload="none"
                                          controls
                                        >
                                          <source src={data.emRespostaAAudio} />
                                        </audio>
                                        {data.tempoAudio && (
                                          <p
                                            style={{
                                              fontWeight: "bolder",
                                              marginLeft: "15px",
                                            }}
                                            className="mb-0"
                                          >
                                            {data.tempoAudio}
                                          </p>
                                        )}
                                      </>
                                    )}
                                  </>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              style={{
                                background: "white",
                              }}
                            >
                              <ListItemText
                                align="left"
                                secondary={data.sent}
                              ></ListItemText>
                            </Grid>
                          </Grid>
                        </ListItem>
                      )}

                      <Grid item xs={12}>
                        <>
                          {data.message !== "" && (
                            <ListItemText
                              style={{ marginLeft: 10, color: "white" }}
                              align="left"
                              primary={data.message}
                            ></ListItemText>
                          )}
                          {data.audio !== "" && (
                            <>
                              <audio
                                id={`audio${data.messageId}`}
                                preload="none"
                                controls
                              >
                                <source src={data.audio} />
                              </audio>
                              {data.tempoAudio && (
                                <p
                                  style={{
                                    fontWeight: "bolder",
                                    marginLeft: "15px",
                                    color: "white",
                                  }}
                                  className="mb-0"
                                >
                                  {data.tempoAudio}
                                </p>
                              )}
                            </>
                          )}
                        </>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        background: "white",
                      }}
                    >
                      <ListItemText
                        align="left"
                        secondary={data.sent}
                      ></ListItemText>
                    </Grid>
                  </Grid>
                </ListItem>
              )}
            </>
          </List>
        </Grid>
      </Grid>
    </div>
  );
};

export default Message;
